export const DEFAULT_ITEM_SIZE = 32;
